import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledProgressBar } from './progress-bar.styles';

const ProgressBar = ({
  totalPages,
  localizedCurrentPage,
  setLocalize
}) => {
  const [state, dispatch] = useContext(Context);

  const handleChange = e => {
    e.preventDefault()
    let currentPage = e.target.value;
    if (!state.isSinglePageMode) {
      currentPage = e.target.value * 2;
    }
    dispatch({
      type: 'SET_CURRENT_PAGE',
      payload: parseInt(currentPage),
    });
  };

  return (
    <StyledProgressBar
      type="range"
      min={0}
      // В Дуал моде длинна прогресс бара берется из длинны 
      // массива спаренных страниц и корректировка от 0 индекса
      max={state.isSinglePageMode ? totalPages - 1 : state.pairsPagesHtmlUrls.length - 1}
      value={state.isSinglePageMode ? localizedCurrentPage : localizedCurrentPage / 2}
      step={1}
      onChange={e => setLocalize(e.target.value)}
      onMouseUp={e => handleChange(e)}
      onKeyDown={e => e.preventDefault()}
      percentage={`${
        state.isSinglePageMode
        ? (parseInt(localizedCurrentPage) /  (totalPages - 1)) * 100
        // В дуал моде % прогресс бара высчитывается на основе массива спаренных страниц
        : (parseInt(Math.ceil(localizedCurrentPage / 2)) /  (state.pairsPagesHtmlUrls.length - 1)) * 100
      }%`}
    />
  );
};

export default ProgressBar;
